import React from 'react';
import { useMediaQuery } from 'react-responsive';

import {
  MEDIA_QUERY_SMALL_SCREEN,
} from 'client/constants/mediaQueries';

import SrModalV2, {
  MODAL_THEME_STACK,
} from 'client/components/SrModalV2/SrModalV2';
import SrButton, {
  SR_BUTTON_THEME_ADOBE_GREY,
  SR_BUTTON_THEME_ADOBE_GREEN,
} from 'client/components/SrButton/SrButton';
import SrBox from 'client/components/SrBox';
import SrFlex from 'client/components/SrFlex';
import SrText from 'client/components/SrText';

import './SrAskWantsToApplyModal.less';

const SrWantsToApplyModal = ({
  listing,
  onWantsToApply,
  onClose,
}) => {
  const isSmallScreen = useMediaQuery({
    query: MEDIA_QUERY_SMALL_SCREEN,
  });

  return (
    <SrModalV2
      showCloseButton={false}
      closeOnBackgroundClick
      onClose={onClose}
      contentMaxWidth={!isSmallScreen ? '375px' : null}
      padding='0'
      theme={MODAL_THEME_STACK}
    >
      <div styleName='container'>
        <SrBox
          styleName='propertyImage'
          backgroundImage={`url("${listing.sunroomPhotoUrls[0]}")`}
        />
        <SrBox direction='col' margin='24px 0' width='100%'>
          <SrText
            font='greycliff'
            weight='800'
            size='21'
            paddingTop='16px'
            lineHeight='30px'
            align='center'
            display='block'
          >
            Would you like to apply for  <br />
            {listing.addressStreetDisplay}?
          </SrText>
          <SrFlex direction='col' padding='25px'>
            <SrButton
              hasBoxShadow
              theme={SR_BUTTON_THEME_ADOBE_GREEN}
              onClick={onWantsToApply}
            >
              I Want to Apply!
            </SrButton>
            <SrBox height='18px' />
            <SrButton
              theme={SR_BUTTON_THEME_ADOBE_GREY}
              onClick={onClose}
            >
              No Thanks
            </SrButton>
          </SrFlex>
        </SrBox>
      </div>
    </SrModalV2>
  );
};

SrWantsToApplyModal.displayName = 'SrWantsToApplyModal';

export default SrWantsToApplyModal;
